import { prefixObjectValues } from '../../utils';
const form = {
  listingTitle: 'listing-title',
  listingDescription: 'listing-description',
  providerCategory: 'provider-category',
  aoiSpecialty: 'aoi-specialty',
  subspecialties: 'subspecialties',
  generalSpecialtyFlag: 'general-specialty-flag',
  isRenewable: 'is-renewable',
  workLocation: 'work-location',
};
export default prefixObjectValues(form, 'basic-info-form');
